<template>
  <tippy
    v-bind:placement="placement"
    :delay="delay"
    trigger="mouseenter"
    touch="false"
    :arrow="arrow"
    :distance="distance"
    theme="topquiz"
    animateFill="false"
    animation="scale"
    interactive="false"
    a11y="false"
    v-bind:toSelector="selector"
  >
    <template v-slot:trigger>
      <slot name="trigger"></slot>
    </template>

    <div class="card">
      <div v-if="!noHeader" class="card-header text-big">
        <slot name="title"></slot>
      </div>
      <div class="card-body pb-0 pt-3">
        <slot></slot>
      </div>
    </div>
  </tippy>
</template>

<script>
export default {
  name: "TopquizTippy",
  props: {
    placement: {
      default: "right"
    },
    noHeader: {
      default: false
    },
    selector: {
      default: undefined
    },
    arrow: {
      default: false
    },
    distance: {
      default: 0
    },
    delay: {
      default() {
        return [300, 100];
      }
    },
    fillTrigger() {
      return this.selector === undefined;
    }
  }
};
</script>
